/* eslint-disable */

import Vue from "vue";
import Router from '../../router';

let NoNameApi = {}
import Vue2Storage from 'vue2-storage'

Vue.use(Vue2Storage, {
    prefix: 'noname_',
    driver: 'local',
    ttl: 60 * 60 * 24 * 1000
})

let refreshTokenPromise;

NoNameApi.install = function(Vue, options) {

    const configElement = document.getElementById('userConfig');
    const userConfig = JSON.parse(configElement.innerHTML);

    Vue.prototype.$noname = {
        urls: {
            base: userConfig.api_base || 'https://api.telecola.tv/v1/',
            accounts: 'accounts/',
            packages: 'packages/',
            channels: 'channels/',
            channels_select: 'channels/select',
            streams: 'streams/',
            services: 'services/',
            colocations: 'colocations/',
            categories: 'categories/',
            roles: 'roles/',
            users: 'members/',
            login: 'auth/login',
            refresh: 'auth/refresh',
            me: 'auth/me',
            epg_sources: 'epgsources/',
            epg_sources_channels: 'epgsources/channels',
            statistics: 'statistics/',
            statistics_count: 'statistics_count/',
            statistics_channels_report_by_date: 'statistics/channels_report_by_date',
            statistics_unique_accounts: 'statistics/unique_accounts',
            statistics_partners_count_by_types: 'statistics/partners_count_by_types',
            statistics_accounts_by_partner_and_by_dates: 'statistics/accounts_by_partner_and_by_dates',
            acc_types_select: 'accounts/acc_types_select',
            logrequests: 'logrequests/',
            logsessions: 'logrequests/sessions_by_ip',
            apks: 'apks/',
            geo_country_codes: 'geo_country_codes/',
            clone_streams: 'services/clone_streams',
            streams: 'streams/',
            vod_movies:     'vod_movies/',
            vod_genres:     'vod_genres/',
            vod_packages:   'vod_packages/',
            countries:      'countries/',
            vod_services:   'vod_services/',
            vod_streams:   'vod_streams/',
        },
        httpOptions: {
            emulateJSON: true,
            withCredentials: true,
            headers: { 'Content-Type': 'application/json' },
        },
        getUrl(urlSlug) {
            return this.urls.base + this.urls[urlSlug]
        },
        get(url, options = {}) {
            options = Object.assign({}, options, this.httpOptions)

            return Vue.axios.get(
                this.getUrl(url),
                options
            )
        },
        getChild(url, id, child, options = {}) {
            options = Object.assign({}, options, this.httpOptions)
            return Vue.axios.get(
                this.getUrl(url) + id + '/' + child,
                options
            )
        },
        postChild(url, id, child, body = {}, options = {}) {
            options = Object.assign({}, options, this.httpOptions)

            return Vue.axios.post(
                this.getUrl(url) + id + '/' + child,
                body,
                options
            )
        },
        patch(url, id, body = {}, options = {}) {
            options = Object.assign({}, options, this.httpOptions)
            return Vue.axios.patch(
                this.getUrl(url) + id,
                body,
                options
            )
        },
        patchChild(url, id, child, body = {}, options = {}) {
            options = Object.assign({}, options, this.httpOptions)

            return Vue.axios.patch(
                this.getUrl(url) + id + '/' + child,
                body,
                options
            )
        },
        post(url, body = {}, options = {}) {
            options = Object.assign({}, options, this.httpOptions)

            return Vue.axios.post(
                this.getUrl(url),
                body,
                options
            )
        },
        delete(url, id, options = {}) {
            options = Object.assign({}, options, this.httpOptions)

            return Vue.axios.delete(
                this.getUrl(url) + id,
                options
            )
        },
        HandleError(error) {
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle busy state in case of error
            console.log(error);

            if (error.response) {
                if (error.response.status == 401) {

                } else {
                    Vue.notify({
                        group: 'notify',
                        text: 'Ошибка получения данных:<br>' + error.response.status + ' ' + error.response.data.msg,
                        type: 'error',
                    });
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                Vue.notify({
                    group: 'notify',
                    text: 'Ошибка получения данных:<br>' + error.request.status + ' ' + error.request.data.msg,
                    type: 'error',
                });
            } else {
                // Something happened in setting up the request that triggered an Error
                console.log('Error', error.message);
            }



            //location.href = '/logout';

            return []
        }
    }

    Vue.axios.interceptors.request.use((config) => {
        let token = '';

        if (Vue.$storage.get('token_expired', true)) {
            token = Vue.$storage.get('refresh_token', '');
            if (!token) {

                Router.push('/logout');
                return [];
            }
        } else {
            token = Vue.$storage.get('access_token', '');
        }

        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }

        return config;
    })

    Vue.axios.interceptors.response.use((response) => {
        return response
    }, (error) => {
        if (error.response) {
            if (error.response.status == 401 && !Vue.$storage.get('token_expired', '')) {

                refreshTokenPromise = Vue.prototype.$noname.post('refresh', {}, {});

                Vue.$storage.set('token_expired', true);
                let config = error.config;

                return refreshTokenPromise.then((data) => {
                    if (data) {
                        Vue.$storage.set('access_token', data.data.access_token, { ttl: 60 * 60 * 24 * 1000 })
                        Vue.$storage.set('token_expired', false, { ttl: 60 * 60 * 24 * 1000 })

                        return Vue.axios.request(config);
                    } else {
                        Router.push('/logout');
                        Vue.$storage.set('token_expired', false, { ttl: 60 * 60 * 24 * 1000 })

                        return [];
                    }
                });
            }
        }

        return Promise.reject(error);
    })
}

export default NoNameApi



// WEBPACK FOOTER //
// ./src/plugins/noname-api/index.js